import { truncate } from '@/utils/strings';
const ProductRow = ({ item }: any) => {
  const productData = [
    { label: 'Product Name', value: item?.productName ? truncate(item?.productName, 12) : '----' },
    { label: 'SKU', value: item?.sku ? item?.sku : '----' },
    { label: 'Store Location', value: item?.storeName ? item?.storeName : '----' },
    { label: 'Scan Count', value: item?.scanCount ? item?.scanCount : '----' },
    // { label: 'Style', value: item?.style ? item?.style : '----' },
    // { label: 'Color', value: item?.color ? item?.color : '----' },
    // { label: 'UOM', value: item?.uom ? item?.uom : '----' },
  ];

  return (
    <div className="product-info-qr-wrap mb-2 last:mb-0">
      <div className="product-info-qr-row bg-card min-w-max rounded-2xl px-3 py-2.5">
        <ul className="flex items-center justify-between gap-4">
          {productData.map((item, idx) => (
            <li key={idx}>
              <label className="text-muted-gray">{item.label}</label>
              <p className="font-medium">{item.value}</p>
            </li>
          ))}

          <li className="shrink-0">
            <div className="qr-code-img">
              {item?.qr_code?.[0]?.qr_code_imsage_url && (
                <img
                  src={item?.qr_code?.[0]?.qr_code_imsage_url ?? null}
                  alt="qr"
                  className="size-9"
                />
              )}
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ProductRow;
